export default () => (
  <>
    <span style={{ whiteSpace: 'nowrap' }}>877-274-6474</span> or{' '}
    <span style={{ whiteSpace: 'nowrap' }}>212-632-1781</span>
  </>
)
